import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=1525b522"
var script = {}
import style0 from "./PageFooter.vue?vue&type=style&index=0&id=1525b522&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports